import React, {Component} from "react";
import {Redirect} from 'react-router';
import Datetime from "react-datetime";
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {serverError} from '../../redux/global'

import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components

import SearchComponent from "components/Search/AutoCompletePatient.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber,
    isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter, timing, parseQueryParams
} from '../../util/globalHelper'
import moment from 'moment'
// style for this view
import Loader from '../../components/Loader'

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class AddReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            doctor_id: "",
            service: "",
            subType: "",
            imageurl: '',
            clinicList: null,
            slot: "",
            clinicmaster_id: null,
            clinic_id: null,
            clinicMasterList: null,
            clinicsData: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            doctorList: null,
            serviceList: null,
            clinicDetail: null,
            timeSlot: null,
            timeIntervalOpen: null,
            timeIntervalClose: null,
            timingStatic: [],
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            patient: null,
            defaultDate: ""
        };
        this.typeClick = this.typeClick.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.setPhoneNumber = this.setPhoneNumber.bind(this)

    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    handleImageUrl(url) {
        this.setState({
            imageurl: url,
            report_link: this.state.report_link.concat({"link": url, "type": "Lab Report"})
        }, () => {
            this.setState({imageurl: ''})
        });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name ? suggestion.user_id.name : "N/A",
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
        });
        return suggestion.user_id.contact ? suggestion.user_id.contact : "N/A"


    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    currentDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }


    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID, this.props.id.match.params.DateTime);
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id, date) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
                this.setState({clinicMasterList: json.data.data})
            }).catch(error => {
                this.props.serverError(true);
            })
            : this.setState({
                clinicMasterList: {},
                clinicmaster_id: clinicmaster_id(),
                clinic_id: getClinicUserId() === "" ? null : getClinicUserId(),
            }, () => {
                if (this.state.clinic_id !== null) {
                    api.getClinicById(getClinicUserId(), {}).then(json => {
                        this.setState({clinicDetail: json.data.data});
                        date ? this.setState({
                            date: this.formatDate(parseInt(date)),
                            timeSlot: json.data.data && json.data.data.clinic_timings ? json.data.data.clinic_timings[`${new Date(parseInt(date)).getDay() > 0 ? new Date(parseInt(date)).getDay() - 1 : 6}`] : null,
                            finalTime: []
                        }, () => {
                            if (this.state.timeSlot !== null)
                                this.setState({
                                    timeIntervalOpen: this.state.timingStatic.find(o => o.time === this.state.timeSlot.open_time),
                                    timeIntervalClose: this.state.timingStatic.find(o => o.time === this.state.timeSlot.close_time),
                                }, () => {
                                    if (this.state.timeIntervalOpen !== undefined && this.state.timeIntervalClose !== undefined)
                                        this.setState({finalTime: this.newArray(this.state.timeIntervalClose.count, this.state.timeIntervalOpen.count)})
                                })
                        }) : this.handleChangeStartDate(moment())
                    }).catch(error => {
                        this.props.serverError(true);
                    })

                }
            });
        this.setState({date: this.currentDate()});
        this.setState({timingStatic: timing});
        api.getAllDoctors().then(json => {
            this.setState({doctorList: json.data.data})
        }).catch(error => {
            this.props.serverError(true);
        });
        api.getPackages().then(json => {
            this.setState({serviceList: json.data.data})
        }).catch(error => {
            this.props.serverError(true);
        });
        var postBody = {

            "clinic_master_id": "",
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        email: this.state.patientDetail.user_id.email
                    })
                })
            }).catch(error => {
                this.props.serverError(true);
            })
        }

        if (this.props.id.location.search !== "") {
            let JDPatient = parseQueryParams(this.props.id.location.search)
            this.setState({
                name: JDPatient.name ? JDPatient.name : "",
                contactNumber: JDPatient.mobile ? JDPatient.mobile : "",
                autoCompleteValue: JDPatient.mobile ? JDPatient.mobile : ""
            })
        }
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        // if (e.target.name === "clinic_id") {
        //     this.setState({defaultDate: moment()})
        //     this.handleChangeStartDate(moment())
        // }
    }

    componentDidUpdate() {
        if (this.state.clinic_id !== null && (this.state.clinicDetail === null || this.state.clinicDetail !== null && this.state.clinicDetail.clinic_id !== this.state.clinic_id))
            api.getClinicById(this.state.clinic_id, {}).then(json => {
                this.setState({clinicDetail: json.data.data}, () => this.handleChangeStartDate(moment())
                )
            }).catch(error => {
                this.props.serverError(true);
            });

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    render() {
        const {classes} = this.props;
        const {clinicList, clinicsData, clinicMasterList, defaultDate} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList && this.state.doctorList && this.state.serviceList)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Book Appointment</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        {/*New Code Added*/}
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} className="centerDiv">
                                                {isClinicMasterOrClinic() === "" ?
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id"
                                                            className={classes.selectLabel}>
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.clinicmaster_id === null ? "" : this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >{clinicMasterList.map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             value={item.clinicmaster_id}>
                                                                {item.clinicmaster_name}  </MenuItem>
                                                        })}

                                                        </Select>
                                                    </FormControl> : null}
                                            </GridItem>
                                            <GridItem xs={12} sm={6} className="centerDiv">
                                                {(isClinicMasterOrClinic() === "" || isClinicMasterOrClinic()) && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="clinic_id"
                                                            className={classes.selectLabel}>
                                                            Clinic
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.clinic_id === null ? "" : this.state.clinic_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinic_id",
                                                                id: "clinic_id"
                                                            }}>
                                                            {clinicsData.map(item => {
                                                                return <MenuItem key={Math.random()}
                                                                                 classes={{root: classes.selectMenuItem}}
                                                                                 value={item._id}>
                                                                    {item.name}  </MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl> : null}
                                            </GridItem>
                                            {/*Personal Details*/}
                                            <GridItem xs={12} sm={6}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12}>
                                                        {this.props.id.match.params.patientID || this.props.id.location.search !== "" ?
                                                            <CustomInput
                                                                labelText=" Phone Number"
                                                                success={this.state.contactNumberState === "success"}
                                                                error={this.state.contactNumberState === "error"}
                                                                id="url"
                                                                formControlProps={{
                                                                    fullWidth: true,
                                                                    required: true
                                                                }}
                                                                inputProps={{
                                                                    onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                                    value: this.state.contactNumber,

                                                                }}
                                                            /> :
                                                            <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                             name={this.state.name}
                                                                             getSuggestionValue={this.getSuggestionValue}/>}
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <CustomInput
                                                            labelText="Name"
                                                            success={this.state.nameState === "success"}
                                                            error={this.state.nameState === "error"}
                                                            id="name"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                                required: true
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "name", "name"),
                                                                value: this.state.name,
                                                            }}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <CustomInput
                                                            labelText="Email"
                                                            success={this.state.emailState === "success"}
                                                            error={this.state.emailState === "error"}
                                                            id="email"
                                                            formControlProps={{
                                                                fullWidth: true,
                                                            }}
                                                            inputProps={{
                                                                onChange: event =>
                                                                    this.change(event, "email", "email"),
                                                                value: this.state.email,

                                                            }}
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <GridContainer>
                                                    {/*Appointment Details*/}
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl fullWidth>
                                                            {this.state.clinicmaster_id && this.state.clinic_id !== "" && this.state.clinicDetail ?
                                                                <div>
                                                                    <Datetime
                                                                        timeFormat={false}
                                                                        defaultValue={new Date()}
                                                                        //value={this.state.date}
                                                                        name="date"
                                                                        id="appointment_date"
                                                                        dateFormat={"DD MMMM, YYYY"}
                                                                        closeOnSelect={true}
                                                                        onChange={event => this.handleChangeStartDate(event)}
                                                                        inputProps={{placeholder: "Appointment Date"}}/>
                                                                </div> : null}
                                                        </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12}>
                                                        <FormControl fullWidth style={{paddingTop: '27px'}}>
                                                            <label>Available Time Slots</label>
                                                            <div style={{padding: '20px'}}>
                                                                <ul className="appointmentTiming">
                                                                    {this.state.finalTime && this.state.finalTime.length > 0 ? this.state.finalTime.map((item) => {
                                                                        return <li key={Math.random()}>
                                                                            <input name="slot"
                                                                                   defaultChecked={this.state.slot === item.value}
                                                                                   type="radio"
                                                                                   onChange={this.onChangeSelect}
                                                                                   id={item.value} value={item.value}/>
                                                                            <label
                                                                                htmlFor={item.value}>{item.value}</label>
                                                                        </li>
                                                                    }) : "No Time Slot"}
                                                                </ul>
                                                            </div>
                                                        </FormControl>
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>


                                            <GridItem xs={12} sm={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="service"
                                                        className={classes.selectLabel}>
                                                        Packages
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.service}
                                                        onChange={this.handleSimple}
                                                        inputProps={{
                                                            name: "service",
                                                            id: "service"
                                                        }}
                                                    >{this.state.serviceList.map(item => {
                                                        return <MenuItem key={Math.random()}
                                                                         classes={{root: classes.selectMenuItem}}
                                                                         value={item._id}>
                                                            {item.title}  </MenuItem>
                                                    })}

                                                    </Select>
                                                </FormControl>
                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="simple-select"
                                                        className={classes.selectLabel}>
                                                        Doctor
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.doctor_id}
                                                        onChange={this.handleSimple}
                                                        inputProps={{
                                                            name: "doctor_id",
                                                            id: "simple-select"
                                                        }}>
                                                        <MenuItem
                                                            disabled={true}
                                                            classes={{
                                                                root: classes.selectMenuItem,
                                                                selected: classes.selectMenuItemSelected
                                                            }}>
                                                            Select Doctor
                                                        </MenuItem>
                                                        {this.state.clinicDetail !== null && this.state.clinicDetail.clinic_doctors ? this.state.clinicDetail.clinic_doctors.map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             value={item._id}>
                                                                {item.user_id.name}  </MenuItem>
                                                        }) : this.state.doctorList.map(item => {
                                                            return <MenuItem
                                                                key={Math.random()}
                                                                value={item.doctor_id}
                                                                classes={{
                                                                    root: classes.selectMenuItem
                                                                }}>{item.user_details.name}
                                                            </MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <br/><br/>
                                                <label>Reason for Appointment</label>
                                                <TextField
                                                    className="width-full"
                                                    placeholder=""
                                                    multiline={true}
                                                    rows={5}
                                                    id="name"
                                                    rowsMax={10}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "description", "name")
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <br/>
                                    </form>
                                    <br/>

                                    <br/>

                                    <br/>

                                </CardBody>
                                <CardFooter className={"centerDiv"}>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={12} sm={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                            <NavLink to={dashboardRouter(`/appointment/readAppointments`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                        <GridItem xs={12} sm={3}>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    change(event, stateName, type, stateNameEqualTo, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
        }
        if (this.state.email === "") {
            this.setState({emailState: "error"});
        }
        if (this.state.contactNumber === "") {
            this.setState({contactNumberState: "error"});
        }
        var data = this.state.doctor_id ? {
            "clinic_master_id": this.state.clinicmaster_id,
            "clinic_id": this.state.clinic_id,
            "patient_id": this.state.clickedId,
            "local_date_string": this.state.date,
            "doctor_id": this.state.doctor_id,
            "start": this.state.date,
            "name": this.state.name,
            "contact": this.state.autoCompleteValue,
            "email": this.state.email,
            "end": this.state.date,
            "packages": this.state.service,
            "notes": this.state.description,
            "local_start_time": this.state.slot,
        } : {
            "clinic_master_id": this.state.clinicmaster_id,
            "clinic_id": this.state.clinic_id,
            "patient_id": this.state.clickedId,
            "local_date_string": this.state.date,
            "start": this.state.date,
            "name": this.state.name,
            "contact": this.state.autoCompleteValue,
            "email": this.state.email,
            "end": this.state.date,
            "packages": this.state.service,
            "notes": this.state.description,
            "local_start_time": this.state.slot,
        };
        if (this.state.clinicmaster_id !== "" && this.state.clinic_id !== "" && this.state.clickedId !== "" && this.state.date !== "" && this.state.slot !== "" && this.state.name !== "") {
            api.createAppointmentByAdmin(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Appointment Created Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/appointment/view/${json.data.data._id}`))
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

    handleChangeStartDate(event) {
        this.setState({
            timeIntervalOpen: null,
            timeIntervalClose: null,
            date: (event).format('YYYY-MM-DD'),
            timeSlot: this.state.clinicDetail.clinic_timings[`${event.day() > 0 ? event.day() - 1 : 6}`],
            finalTime: []
        }, () => {
            if (this.state.timeSlot !== null)
                this.setState({
                    timeIntervalOpen: this.state.timeSlot.open_24 ? this.state.timingStatic.find(o => o.time === "12:00 AM") : this.state.timingStatic.find(o => o.time === this.state.timeSlot.open_time),
                    timeIntervalClose: this.state.timeSlot.open_24 ? this.state.timingStatic.find(o => o.time === "12:00 AM") : this.state.timingStatic.find(o => o.time === this.state.timeSlot.close_time),
                }, () => {
                    if (this.state.timeIntervalOpen !== undefined && this.state.timeIntervalClose !== undefined)
                        this.state.timeIntervalClose.count !== this.state.timeIntervalOpen.count ? this.setState({finalTime: this.newArray(this.state.timeIntervalClose.count, this.state.timeIntervalOpen.count)}) : this.setState({finalTime: timing})
                })
        });
    }


    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        }).catch(error => {
            this.props.serverError(true);
        });
    }

    newArray(length, start) {
        const ar = timing;
        var cloneArray = ar.slice();
        cloneArray.length = length;
        const newArray = cloneArray.splice(start);
        return newArray
    }
}

const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddReport));



// WEBPACK FOOTER //
// ./src/components/Appointment/bookPackages.jsx